import { connect } from 'react-redux';
import ConversationListComponent from '../components/conversation_list';
import ConversationActions from '../actions/conversation';

import ArrayUtils from '../utils/array';

function mapStateToProps(state) {
  const newConversationIds = state.search.userIds;
  let conversations = state.conversations.edges;
  let newConversationLabels = null;
  let matchingConversation = null;

  if (newConversationIds && newConversationIds.length) {
    const searchMatches = {};

    let conversation, cParticipantIds;
    for (let i = 0; i < conversations.length; i++) {
      conversation = conversations[i].node;
      cParticipantIds = conversation.participants.map(p => p.user.id);
      searchMatches[conversation.id] = cParticipantIds.filter(Set.prototype.has, new Set(newConversationIds));

      if (
        searchMatches[conversation.id].length &&
        ArrayUtils.isEqual(newConversationIds.sort(), cParticipantIds.sort())
      ) {
        matchingConversation = true;
      }
    }

    conversations = conversations.filter(c => searchMatches[c.node.id].length > 0).sort((a, b) => {
      return searchMatches[b.node.id].length - searchMatches[a.node.id].length;
    });

    if (!conversations.length || !matchingConversation) {
      newConversationLabels = state.search.userNames;
    }
  }

  return {
    conversations: conversations,
    newConversation: state.conversationCreator.visible,
    hasActiveConversation: state.activeConversation.hasOwnProperty('id'),
    hasConversations: state.conversations.edges.length > 0,
    hasNextPage: state.conversations.pageInfo.hasNextPage,
    newConversationLabels: newConversationLabels,
    newConversationIds: newConversationIds
  };
}

const ConversationListContainer = connect(
  mapStateToProps,
  {
    selectLoad: ConversationActions.selectLoad,
    fetchNewPage: ConversationActions.fetchNewPage
  }
)(ConversationListComponent);

export default ConversationListContainer;
